import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import './index.css';
import App from './App';
import Login from './components/Login';
import reportWebVitals from './reportWebVitals';

const msalInstance = new PublicClientApplication(msalConfig);

// Determine environment at the top level
const isLocalEnv = process.env.REACT_APP_ENV === 'local';

const AuthenticatedApp = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLocalEnv) {
      const handleRedirect = async () => {
        try {
          await instance.handleRedirectPromise();
        } catch (error) {
          console.error("Error handling redirect:", error);
        } finally {
          setIsLoading(false);
        }
      };

      handleRedirect();
    } else {
      setIsLoading(false); // Skip authentication for local environment
    }
  }, [instance]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Render App directly if in local environment
  return isLocalEnv || isAuthenticated ? <App /> : <Login />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isLocalEnv ? (
      // Directly render App without MSAL provider in local environment
      <App />
    ) : (
      <MsalProvider instance={msalInstance}>
        <AuthenticatedApp />
      </MsalProvider>
    )}
  </React.StrictMode>
);

// Measure performance
reportWebVitals();
